import {DomUtils} from "./domutils.mjs";
import {DocProviderProvider} from "./docprovider.mjs";


export class DomManager{
    constructor(domManagerOptions){
        var _domHead = [];
        var _domNode;


        Object.defineProperty(this,'addDomHeadNode',{
            value : function(node){ _domHead.push(node); }
        });

        Object.defineProperty(this,'getDomHead',{
            value : function(){ 
                var domHead = _domHead.map(node => node);
                return domHead;
            }
        });     
        
        this.domHead = _domHead;


        Object.defineProperty(this,'domNode',{
            set : function(d){ _domNode = d }, 
            get : function(){ return _domNode } 
        });

        // runtime
        this.init(domManagerOptions);        
    }
    // =======
    // private
    // -------
    setDomNode(node){
        this.domNode = node;
    }

    addDomHeadNodes(nodes){
        nodes.forEach(node => this.addDomHeadNode(node) );
    }

    setDomNodeContainer(nodes){
        if (nodes.length >1 ) throw new Error('container is necessary one node');
        var node = nodes[0];
        this.setDomNode(node);
    }

    setDomNodeContent(nodes){
        var parentNode = this.getDomNode();
        DomUtils.removeChilds(parentNode);
        DomUtils.appendChilds(parentNode, nodes);
    }

    buildContainer(containerOptions){
        if (containerOptions){
            var docProvider = DocProviderProvider.get(containerOptions);
            var document = docProvider.getDocument();
            var bodyNodes = DomUtils.documentBodyNodes(document);
            var headNodes = DomUtils.documentHeadNodes(document);
            this.setDomNodeContainer(bodyNodes);
            this.addDomHeadNodes(headNodes);
        }
    }

    buildLayout(contentOptions){
        if (contentOptions){
            var docProvider = DocProviderProvider.get(contentOptions);
            var document = docProvider.getDocument();
            var bodyNodes = DomUtils.documentBodyNodes(document);   
            var headNodes = DomUtils.documentHeadNodes(document);
            this.setDomNodeContent(bodyNodes);
            this.addDomHeadNodes(headNodes);    
        } 
    }

    appendComponent(component){
        if (component){
            var parentNode = this.getDomNode();
            parentNode.getComponent = ()=> component;
        }
    }

    init(domManagerOptions){
        this.buildContainer(domManagerOptions.getContainerOptions());
        this.buildContent(domManagerOptions.getContentOptions());
        this.appendComponent(domManagerOptions.getComponent());
    }

    // =======
     // API (public) 
     // -------
    domUtils(fn, ...params){
        return DomUtils[fn](...params);
    }

    getElementIndex(element,selector){
        return DomUtils.getElementIndex(element,selector, this.getDomNode());
    }


     getDomNode(){ return this.domNode }

  
     getDocument(){ 
         var domNode = this.getDomNode();
         var domHead = this.getDomHead();
         var document = DomUtils.createDocument(domNode,domHead);
         return document; 
     }

    buildContent(contentOptions){
        this.buildLayout(contentOptions);
    }

    getAllChildren(selector){
        var domNode = this.getDomNode();
        return DomUtils.getAllChildren(selector, domNode);
    }

  
    insertSubDocument(document, selector){
        var bodyNodes = DomUtils.documentBodyNodes(document);
        var headNodes = DomUtils.documentHeadNodes(document);
        var domNode = this.getDomNode();
        //this.removeSubDocument(selector); /* if selector is empty will remove all the subdocuments */ 
        var parentNode = DomUtils.getFirstChild(selector, domNode) || domNode;
        this.addDomHeadNodes(headNodes);
        DomUtils.appendChilds(parentNode, bodyNodes);
    }


    insertSubDocuments(documents, selector){
        var domNode = this.getDomNode();
        var parentNode = DomUtils.getFirstChild(selector, domNode) || domNode;
        documents.forEach(document => { 
            this.insertSubDocument(document, selector);
        });     
    }






    /* added 23-05*/
    getParentNode(selector){
        var domNode = this.getDomNode();
        var parentNode = DomUtils.getFirstChild(selector, domNode) || domNode;
        return parentNode;
    }

    /* added 25-05 */
    replaceNode(newNodes, currentNode, selector){
        //var parentNode = this.getParentNode(selector);
        if (!(newNodes && currentNode)) throw new Error('DomManager::replaceDocument. Parameters are undefined')
        var newNode = newNodes.pop(); 

        var parentNode = currentNode.parentElement    
        parentNode.insertBefore(newNode, currentNode) 
        if (currentNode !== newNode) currentNode.remove();
           
        var refNode = newNode;
        while(newNodes.length){
            var newNode = newNodes.pop();
            parentNode.insertBefore(newNode, refNode)
            refNode = newNode; 
        }
    }


    /* added 23-05 */ /* TO DEPRECATE */
    replaceDocument(newDocuments, currentNode, selector){
        //var parentNode = this.getParentNode(selector);
        if (!(newDocuments && currentNode)) throw new Error('DomManager::replaceDocument. Parameters are undefined')
        var newNodes = newDocuments.map(newDocument =>{ 
            var nodes = DomUtils.documentBodyNodes(newDocument);
            if (nodes.length !== 1) throw new Error('DomManager::replaceDocument. Document should have only one node');
            return nodes[0]; 
        });
        var newNode = newNodes.pop(); 

        var parentNode = currentNode.parentElement    
        if (currentNode !== newNode){
            parentNode.insertBefore(newNode, currentNode) 
            currentNode.remove();
        }   
        var refNode = newNode;
        while(newNodes.length){
            var newNode = newNodes.pop();
            parentNode.insertBefore(newNode, refNode)
            refNode = newNode; 
        }
    }

    /* added 23-05 */
    removeNode(node){
        node.remove(); 
    }


    /* added 23-05 */
    removeSubDocument2(document){
        var bodyNodes = DomUtils.documentBodyNodes(document);
        var headNodes = DomUtils.documentHeadNodes(document);
        bodyNodes.forEach(bodyNode => bodyNode.remove());
        headNodes.forEach(headNode => headNode.remove());
    }

    /* added 13-05-2021 */
    removeSubDocument(parentSelector){
        var domNode = this.getDomNode();
        var parentNode = DomUtils.getFirstChild(parentSelector, domNode) || domNode;
        DomUtils.removeChilds(parentNode)
    }

    addClassList(classes, selector){
        var domNode = this.getDomNode();
        var node = domNode;
        if (selector) node = DomUtils.getFirstChild(selector, domNode);
        DomUtils.addClassList(classes, node);
    }
    
}


/**
 * DomManagerOptions 
 */

export class DomManagerOptions{
    constructor(containerOptions, contentOptions, component){
        var _containerOptions = containerOptions;
        var _contentOptions = contentOptions;
        var _component = component;

        Object.defineProperty(this,'containerOptions',{
            set : function(c){ 
                if (c instanceof DocPartsOptions)
                _containerOptions = c 
            },
            get : function(){ return _containerOptions; }
        });

        Object.defineProperty(this,'contentOptions',{
            set : function(c){ _contentOptions = c },
            get : function(){ return _contentOptions; }
        })

        Object.defineProperty(this,'component',{
            set : function(o){ _component = o },
            get : function(){ return _component }
        })
    }

    getContainerOptions(){ return this.containerOptions; }

    getContentOptions(){ return this.contentOptions; }

    setContentOptions(c){ this.contentOptions = c; }

    getComponent(){ return this.component; }

    setContext(context){ 
        this.getContentOptions().setContext(context);
    }
}